// Standard Library

// 3rd Party

// Local
import { LubooDefaultShell } from './default/luboo.shell.js';

/**
 * Default module kickoff - Initializes core functionality on all pages
 */
const kickoff = () => {
  // Create global default instance
  window.luboo = new LubooDefaultShell({
    $cont: document.body,
  });
};

// Initialize when DOM is ready
if (document.readyState !== 'loading') {
  kickoff();
} else {
  document.addEventListener('DOMContentLoaded', kickoff);
}
